import React, { useState } from 'react';

import { Surface } from '@infoods/lifebase-ui';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

import classes from './CustomerAnalyticsWidget.module.scss';
import { WidgetTitle } from '../../../../components/WidgetTitle/WidgetTitle';
import { DateRangeFilterTabs } from '../../../../../shared/components/tabs';
import {
  DATE_RANGE_PRESETS,
  DateRangePreset,
} from '../../../../../shared/constants/dateRangePreset';
import { StatisticInfoCard } from '../../../../../shared/components/StatisticInfoCard/StatisticInfoCard';
import { useCustomerAnalytics } from './hooks/useCustomerAnalytics';
import { getComparisonPeriodForPreset } from '../../../../../shared/utils/getComparisonPeriodForPreset/getComparisonPeriodForPreset';

const DEFAULT_DATE_RANGE_PRESET: DateRangePreset = DATE_RANGE_PRESETS['7D'];

const CustomerAnalyticsWidget = () => {
  const [dateRangePreset, setDateRangePreset] = useState<DateRangePreset>(
    DEFAULT_DATE_RANGE_PRESET,
  );

  const { customerAnalytics } = useCustomerAnalytics({ dateRangePreset });

  const period = getComparisonPeriodForPreset(dateRangePreset);

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Customer Analytics"
        icon={<AssessmentOutlinedIcon fontSize="small" />}
        endAdornment={
          <DateRangeFilterTabs
            value={dateRangePreset}
            onValueChange={setDateRangePreset}
          />
        }
      />
      {customerAnalytics && (
        <div className={classes.row}>
          <StatisticInfoCard
            title={
              <>
                Scans
                <br />
                This Period
              </>
            }
            value={customerAnalytics.newScans}
            period={period}
          />
          <StatisticInfoCard
            title={
              <>
                Total
                <br />
                Scans
              </>
            }
            value={customerAnalytics.totalScans}
            comparingPercentage={customerAnalytics.totalScansDiffPercent}
            period={period}
          />
          <StatisticInfoCard
            title={
              <>
                Total
                <br />
                Customers
              </>
            }
            value={customerAnalytics.totalCustomers}
          />
        </div>
      )}
    </Surface>
  );
};

export { CustomerAnalyticsWidget };
